import { getSystemTimeZone, format } from '@flex-packages/date';
import { useCallback } from 'react';

const useFormat = ({ locale }) => {
  const timeZone = getSystemTimeZone();
  const _format = useCallback(
    (params) => {
      const { presetName, date } = params;
      return format({
        presetName,
        date,
        locale,
        timeZone
      });
    },
    [locale, timeZone]
  );
  return _format;
};

export { useFormat };
//# sourceMappingURL=useFormatV2.mjs.map
